const NoneStringRenderer = (props) => {
  return props.value === null ? 'None' : props.value;
};

export default NoneStringRenderer;
